import { useMemo } from 'react';
import { useGetPortalNavigationQuery } from '../../__generated__/chirp/com/hubspot/portals/platform/app/rpc/NavigationRpc.hooks';
import { getPortalAccountId, getPortalInstanceId, getIsPortalDeployed } from '../utils/metadata';
function toSideNavItem(item, hrefBase, isCurrent) {
  var _item$badge, _item$children;
  return {
    id: item.id,
    href: item.path ? `${hrefBase}${item.path}` : undefined,
    path: item.path,
    isCurrent,
    external: item.external,
    badgeCount: (_item$badge = item.badge) === null || _item$badge === void 0 ? void 0 : _item$badge.count,
    children: ((_item$children = item.children) !== null && _item$children !== void 0 ? _item$children : []).slice().sort((a, b) => {
      var _a$order, _b$order;
      return ((_a$order = a.order) !== null && _a$order !== void 0 ? _a$order : 0) - ((_b$order = b.order) !== null && _b$order !== void 0 ? _b$order : 0);
    }).map(child => toSideNavItem(child, hrefBase, isCurrent))
  };
}
export function usePortalNavigation() {
  var _data$siteMenuData, _siteMenuData$items$l, _siteMenuData$items, _data$portalNavigatio2;
  const {
    data,
    loading
  } = useGetPortalNavigationQuery({
    variables: {
      accountId: getPortalAccountId(),
      portalInstanceId: getPortalInstanceId()
    }
  });
  const navItems = useMemo(() => {
    var _data$portalNavigatio;
    const isLocal = !getIsPortalDeployed();
    const entries = (_data$portalNavigatio = data === null || data === void 0 ? void 0 : data.portalNavigationEntries) !== null && _data$portalNavigatio !== void 0 ? _data$portalNavigatio : [];
    return entries.flatMap(entry => {
      var _entry$navigationMani;
      if (!((_entry$navigationMani = entry.navigationManifest) !== null && _entry$navigationMani !== void 0 && _entry$navigationMani.items)) return [];
      const hrefBase = isLocal ? new URL(`https://${entry.baseUrl}`).pathname.replace(/\/$/, '') : entry.baseUrl;
      return entry.navigationManifest.items.slice().sort((a, b) => {
        var _a$order2, _b$order2;
        return ((_a$order2 = a.order) !== null && _a$order2 !== void 0 ? _a$order2 : 0) - ((_b$order2 = b.order) !== null && _b$order2 !== void 0 ? _b$order2 : 0);
      }).flatMap(item => {
        const navItem = toSideNavItem(item, hrefBase, entry.isCurrent);
        return navItem.children.length > 0 ? navItem.children : [navItem];
      });
    });
  }, [data]);
  const siteMenuData = (_data$siteMenuData = data === null || data === void 0 ? void 0 : data.siteMenuData) !== null && _data$siteMenuData !== void 0 ? _data$siteMenuData : undefined;
  const siteMenuItemCount = (_siteMenuData$items$l = siteMenuData === null || siteMenuData === void 0 || (_siteMenuData$items = siteMenuData.items) === null || _siteMenuData$items === void 0 ? void 0 : _siteMenuData$items.length) !== null && _siteMenuData$items$l !== void 0 ? _siteMenuData$items$l : 0;
  const nonUniversalDestinationCount = ((_data$portalNavigatio2 = data === null || data === void 0 ? void 0 : data.portalNavigationEntries) !== null && _data$portalNavigatio2 !== void 0 ? _data$portalNavigatio2 : []).filter(entry => entry.portalInstanceType !== 'UNIVERSAL').reduce((count, entry) => {
    var _entry$navigationMani2, _entry$navigationMani3;
    const items = (_entry$navigationMani2 = (_entry$navigationMani3 = entry.navigationManifest) === null || _entry$navigationMani3 === void 0 ? void 0 : _entry$navigationMani3.items) !== null && _entry$navigationMani2 !== void 0 ? _entry$navigationMani2 : [];
    return count + items.reduce((itemCount, item) => {
      var _item$children2;
      const children = (_item$children2 = item.children) !== null && _item$children2 !== void 0 ? _item$children2 : [];
      return itemCount + (children.length > 0 ? children.length : 1);
    }, 0);
  }, 0);
  const shouldShowSideNav = loading || nonUniversalDestinationCount > 1 || siteMenuItemCount > 0;
  return {
    navItems,
    siteMenuData,
    shouldShowSideNav
  };
}